import React, { useEffect, useState } from "react";
import Dropdown from "../../component/dropdown";
import FilterButton from "../../component/dropdown-filter";
import PaginationClassic from "../../component/pagination-classic";
import Table, { TableRow } from "../../component/table";
import { Bin, Edit, Reload, Submit, View } from "../../component/icons";
import Modal from "../../component/layout/modal";
import Stepper from "react-stepper-horizontal/lib/Stepper";

const AssignmentJob = (props) => {
  const [assignments, setAssignments] = useState([]);
  const [toBeDeleted, setToBeDeleted] = useState(null);
  const [currentSteps, setCurrentSteps] = useState(2);

  const handleDelete = () => {
    setAssignments(assignments.filter((a) => a.id !== toBeDeleted));
    setToBeDeleted(null);
  };

  // const handleStepperClick = (e) => {
  //   e.preventDefault();
  //   console.log(e);
  // };

  const steps = [
    {
      title: "previous activity",
      onClick: (e) => {
        e.preventDefault();
        setCurrentSteps(0);
      },
    },
    {
      title: "previous activity",
      onClick: (e) => {
        e.preventDefault();
        setCurrentSteps(1);
      },
    },
    {
      title: "current activity",
      onClick: (e) => {
        e.preventDefault();
        setCurrentSteps(2);
      },
    },
    {
      title: "next activity",
      onClick: (e) => {
        e.preventDefault();
      },
    },
    {
      title: "next activity",
      onClick: (e) => {
        e.preventDefault();
      },
    },
    {
      title: `next
      activity`,
      onClick: (e) => {
        e.preventDefault();
      },
    },
    {
      title: "next activity",
      onClick: (e) => {
        e.preventDefault();
      },
    },
  ];

  useEffect(() => {
    setAssignments(items);
  }, []);

  return (
    <div className="mt-4 sm:mx-6 lg:mx-8">
      <header className="sm:flex sm:justify-between sm:items-center mb-5">
        <div className="mb-4 sm:mb-0">
          <h1 className="text-2xl md:text-3xl text-slate-800 font-bold">
            Assignment
          </h1>
        </div>
        <div className="flex flex-col sm:flex-row justify-start sm:justify-end gap-2">
          <Dropdown
            prefix={
              <svg
                className="w-4 h-4 fill-current text-slate-500 shrink-0 mr-2"
                viewBox="0 0 16 16"
              >
                <path d="M15 2h-2V0h-2v2H9V0H7v2H5V0H3v2H1a1 1 0 00-1 1v12a1 1 0 001 1h14a1 1 0 001-1V3a1 1 0 00-1-1zm-1 12H2V6h12v8z" />
              </svg>
            }
          />
          <div className="flex">
            <FilterButton align="right" />
            {/* Add customer button */}
            <button className="btn flex-auto ml-3 !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white">
              <svg
                className="w-4 h-4 fill-current opacity-50 shrink-0 mr-2"
                viewBox="0 0 16 16"
              >
                <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
              </svg>
              Assign
            </button>
          </div>
        </div>
      </header>

      <div>
        <div>Job name #JOB_NAME</div>
        <div className="mt-2">
          <span className="text-blue-500 cursor-pointer pr-4 text-sm">
            Other Custome Field
          </span>
          <span className="cursor-pointer pr-4 text-sm">
            Other Custome Field
          </span>
          <span className="cursor-pointer pr-4 text-sm">
            Other Custome Field
          </span>
        </div>
      </div>

      {/* Stepper Code start */}
      <Stepper
        steps={steps}
        activeStep={currentSteps}
        activeColor="#6366F1"
        activeBorderColor="#6366F1"
        completeColor="#ffffff"
        completeBorderColor="#94A3B8"
        completeTitleColor="#64748B"
        size={16}
        circleFontSize={0}
        defaultColor="#F43F5E"
        defaultBorderColor="#F43F5E"
        defaultBarColor="#E2E8F0"
        defaultTitleColor="#64748B"
        lineMarginOffset={2}
        titleFontSize={14}
      />
      {/* Stepper code end */}

      <div className="text-right mt-3">
        <button
          className="btn bg-white border-slate-200 hover:border-slate-300 text-[--bg-color-500]"
          onClick={(e) => {
            e.preventDefault();
            setCurrentSteps((step) => step + 1);
          }}
        >
          Next -&gt;
        </button>
      </div>

      <div className="mt-4">
        <div className="text-gray-900">Status 1</div>
        <div className="flex flex-row items-center justify-between bg-white h-20 shadow-xl p-2 border border-gray-200 rounded">
          {/* Info */}
          <div className="flex flex-row space-x-3">
            <div className="h-10 w-10 bg-gray-400 text-gray-900 rounded-full flex justify-center items-center text-2xl">
              A
            </div>
            <div>
              <div className="text-gray-700">
                #1234123{" "}
                <span className="font-bold text-gray-900">- Activty A</span>
              </div>
              <div className="flex flex-row items-center">
                <span className="text-gray-600 text-sm pr-3">Robin Laseur</span>
                <span className="cursor-pointer">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="w-4 h-4"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                    />
                  </svg>
                </span>
              </div>
            </div>
          </div>
          {/* Department */}
          <div>
            <div className="text-gray-700 text-sm font-semibold">
              Department
            </div>
            <div className="flex flex-row items-center">
              <span className="text-gray-600 text-sm pr-3">Department A</span>
              <span className="cursor-pointer">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-4 h-4"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                  />
                </svg>
              </span>
            </div>
          </div>

          {/* ETA */}
          <div>
            <div className="text-gray-700 text-sm font-semibold">ETA</div>
            <div className="flex flex-row items-center">
              <span className="text-gray-600 text-sm pr-3">22/02/2022</span>
              <span className="cursor-pointer">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-4 h-4"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                  />
                </svg>
              </span>
            </div>
          </div>

          {/* Remainder */}
          <div>
            <div className="text-gray-700 text-sm font-semibold">Remainder</div>
            <div className="flex flex-row items-center">
              <span className="text-gray-600 text-sm pr-3">22/02/2022</span>
              <span className="cursor-pointer">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-4 h-4"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                  />
                </svg>
              </span>
            </div>
          </div>

          {/* Link Activity */}
          <div>
            <div className="text-gray-700 text-sm font-semibold">
              Link To Do
            </div>
            <div className="flex flex-row items-center">
              <span className="text-gray-600 text-sm pr-3">Select</span>
              <span className="cursor-pointer">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-4 h-4"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                  />
                </svg>
              </span>
            </div>
          </div>

          {/* Actions */}
          <div className="flex items-center space-x-1 px-2 py-3 whitespace-nowrap">
            <Reload tag="button" type="button" title="Reload" />
            <View tag="button" title="View" />
            <Edit tag="button" type="button" title="Edit" />
            <Bin tag="button" type="button" title="Delete" />
          </div>
        </div>
      </div>

      {/* <div className="overflow-x-auto shadow-lg rounded border mt-5">
        <Table
          heads={[
            "id",
            "activity name",
            "assign to",
            "eta",
            "user",
            "remember",
            "actions",
          ]}
          tClass="table-auto w-full"
          hClass="text-xs font-semibold uppercase text-slate-500 bg-slate-50 border-t border-b border-slate-200"
          bClass="text-sm divide-y divide-slate-200"
          thClass="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap text-left font-semibold "
        >
          {assignments.map((assignment, i) => (
            <TableRow
              key={i}
              row={assignment}
              trClass="odd:bg-white"
              tdClass="px-2 whitespace-nowrap font-medium first:text-sky-500 first:pl-5 last:pr-5 "
            >
              <td className="flex space-x-1 px-2 py-2 whitespace-nowrap font-medium first:text-sky-500 first:pl-5 last:pr-5">
                <View tag="button" type="button" title="View" />
                <Edit tag="button" type="button" title="Edit" />
                <Bin
                  tag="button"
                  type="button"
                  title="Delete"
                  onClick={() => setToBeDeleted(assignment.id)}
                />
              </td>
            </TableRow>
          ))}
        </Table>
      </div> */}

      <Modal
        id="danger-modal"
        open={!!toBeDeleted}
        title="Delete activity"
        description="Are you sure you want to delete your activity? All of your data will be permanently removed from our servers forever. This action cannot be undone."
        onCancel={() => setToBeDeleted(null)}
        onApprove={handleDelete}
        cancelBtnText="Cancel"
        okBtnText="Delete"
      />

      {/* Pagination */}
      {/* <div className="mt-8">
        <PaginationClassic />
      </div> */}
    </div>
  );
};

AssignmentJob.auth = { path: "/assignment/assign-jobs", role: "super-admin" };
export default AssignmentJob;

const items = [
  {
    id: "#456780",
    name: "Activity 1",
    assignee: "assignee 1",
    eta: "21/06/2021",
    selectedUser: "User 1",
    reminder: "29/06/2021",
  },
  {
    id: "#456781",
    name: "Activity 2",
    assignee: "assignee 2",
    eta: "17/06/2021",
    selectedUser: "",
    reminder: "17/06/2021",
  },
];
